import React from 'react';
import radium from 'radium';
import Header from '../header/Header.jsx';
import Footer from '../footer/Footer.jsx';
import TitleHeader from '../title-header/TitleHeader.jsx';
import { ThemeContext } from '../theme/Theme.jsx'
// Styles
import './Reset.scss';
import './Layout.scss';

class Layout extends React.Component {
	static contextType = ThemeContext;

	constructor(props) {
		super(props);

		this.state = {
			style: {
				minHeight: '100vh',
				height: 'auto',
			},
		};
	}

	componentDidMount() {
		window.addEventListener('resize', () => this.calcViewportHeight());
		window.addEventListener('onorientationchange', () => this.calcViewportHeight());
		this.calcViewportHeight();
	}

	calcViewportHeight() {
		const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		this.setState({
			style: {
				minHeight: `${vh}px`,
				height: this.props.fixHeight ? `${vh}px` : 'auto',
			},
		});
	}

	render() {
		const style_ = {
			layout: {
				fontFamily: this.context.themeManager.value('layout', 'fontFamily', 'text-font-family-standart'),
				fontSize: this.context.themeManager.value('layout', 'fontSize', 'layout-font-size'),
				color: this.context.themeManager.value('layout', 'color', 'fg-color-text'),
				background: this.context.themeManager.value('layout', 'background'),
			},
			contentWrapper: {
				'@media (min-width : 768px)': {
					borderLeft: this.context.themeManager
						.value('layout', 'contentBorderLeft', 'content-border-left'),
					borderRight: this.context.themeManager
						.value('layout', 'contentBorderRight', 'content-border-right'),
					borderBottom: this.context.themeManager
						.value('layout', 'contentBorderBottom', 'content-border-bottom'),
					paddingLeft: '0',
					paddingRight: '0',
				},
			},
			contentWrapperWithoutBorder: {
				'@media (min-width : 768px)': {
					paddingLeft: '0',
					paddingRight: '0',
				},
			},

			hideMobile: {
				'@media (max-width : 767px)': {
					display: 'none',
				},
			},
		};
		const paddingTop = this.props.removePaddingTop ? '0' : this.context.themeManager
			.value('layout', 'contentPaddingTop', 'content-padding-top');
		const paddingSide = this.props.paddingSide ? this.props.paddingSide : '0.5em';
		const paddingBotom = this.context.themeManager
			.value('layout', 'contentPaddingBottom', 'content-padding-bottom');
		const contentWrapperBackground = this.context.themeManager
			.value('content-wrapper', 'background');
		const style = {
			paddingTop,
			paddingLeft: paddingSide,
			paddingRight: paddingSide,
			paddingBottom: paddingBotom,
			background: contentWrapperBackground,
		};

		return (
			<div className="" style={style_.layout} id="layout">
				<main id="leo-content" style={this.state.style} className="layout" aria-hidden="false">
					{!this.props.hideHeader &&
						<Header/>
					}
					{this.props.displayTitle &&
						<TitleHeader/>
					}

					<div
						className="content__wrapper"
						style={[
							style,
							this.props.hideBorders ?
								style_.contentWrapperWithoutBorder : style_.contentWrapper,
						]}
					>
						{this.props.content}
					</div>
					{!this.props.hideFooter &&
						<Footer style={this.props.hideFooterMobile ? style_.hideMobile : ''}/>
					}
				</main>
				<div id="leo-popup" aria-hidden={true} className="layout"></div>
			</div>
		);
	}
}

export default radium(Layout);
